import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../admin/AdminAuthContext';

export const AdminGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { loading, adminOk } = useAdminAuth();
  const loc = useLocation();

  if (loading) {
    return <div style={{ padding: 20, color: '#b1b8c7' }}>Checking admin session…</div>;
  }

  if (!adminOk) {
    return <Navigate to="/admin/login" replace state={{ next: loc.pathname }} />;
  }

  return <>{children}</>;
};
